<template>
  <div class="promotion">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Performance Activity</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Performance Activity</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  @click="openDialog"
                  class="btn add-btn"
                  ><i class="fa fa-plus"></i> Add Performance Activity</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
               
                <v-data-table
                  :headers="headers"
                  :items="performanceActivities"
                  sort-by=""
                  class="elevation-1"
                >

              <template v-slot:[`item.actions`]="{  }">
        
                <div class="dropdown dropdown-action">
                  <a
                    href="#"
                    class="action-icon dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    ><i class="material-icons">more_vert</i></a
                  >
                  <div class="dropdown-menu dropdown-menu-right">
                    <a
                      class="dropdown-item"
                      ><i class="fa fa-pencil m-r-5"></i> Edit</a
                    >
                    <a
                      class="dropdown-item"
                      ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                    >
                  </div>
                </div>
              </template>
              <template v-slot:[`item.profile`]="{  }">
                <h2 class="table-avatar blue-link">
                  <router-link to="/profile" class="avatar"
                    ><img alt="" src="~@/assets/profiles/avatar-02.jpg"
                  /></router-link>
                  <router-link to="/profile">
                    Adele Vance
                  </router-link>
                </h2>
              </template>
            </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Promotion Modal -->
        <v-dialog v-model="dialog" max-width="725px"
          >
        <!-- <div id="add_promotion" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document"> -->


            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Performance Activity</h5>
                <button
                  type="button"
                  class="close"
                  @click="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label
                      >Employee <span class="text-danger">*</span></label
                    >
                    <select placeholder="Select Employee" class="form-control">
                      <option disabled value="">Select Employee</option>
                      <option
                        v-for="item in employees"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ `${item.firstName} ${item.lastName}` }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label
                      >Activity Type <span class="text-danger">*</span></label
                    >
                    <select class="form-control">
                      <option disabled value="">
                        Select Activity Type
                      </option>
                      <option>
                        Leads
                      </option>
                      <option>
                        Opportunities
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label
                      >Description <span class="text-danger">*</span></label
                    >
                    <textarea type="text" class="form-control">
                    </textarea>
                  </div>
                  <div class="form-group">
                    <label
                      >Date <span class="text-danger">*</span></label
                    >
                    <div class="cal-icon">
                      <datepicker
                        calendar-class
                        input-class
                        bootstrap-styling
                        class="form-control datetimepicker"
                        type="text"
                      />
                    </div>
                  </div>

                  <div class="submit-section">
                    <button
                      @click.prevent="onSubmit"
                      data-dismiss="modal"
                      class="btn btn-primary submit-btn"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>

            
          <!-- </div>
        </div> -->

        </v-dialog>
        <!-- /Add Promotion Modal -->

        <!-- Edit Promotion Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px"
          >

        <!-- <div id="edit_promotion" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document"> -->

            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Promotion</h5>
                <button
                  type="button"
                  class="close"
                  @click="closeEdit"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label
                      >Promotion For <span class="text-danger">*</span></label
                    >
                    <select class="form-control">
                      <option>Select Employee</option>
                      <option
                        v-for="item in employees"
                        :key="item.id"
                        :value="item.id"
                      >
                        Adele Vance
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label
                      >Promotion From <span class="text-danger">*</span></label
                    >
                    <input type="text" readonly class="form-control" />
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Save</button>
                  </div>
                </form>
              </div>
            </div>

            
          <!-- </div>
        </div> -->

        </v-dialog>
        <!-- /Edit Promotion Modal -->

        <!-- Delete Promotion Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px"
          >

        <!-- <div
          class="modal custom-modal fade"
          id="delete_promotion"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered"> -->
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Promotion</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click.prevent="deletePromotion"
                        class="btn btn-primary continue-btn"
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        href="javascript:void(0);"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <!-- </div>
        </div> -->

        </v-dialog>
        <!-- /Delete Promotion Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import { organizationService } from "@/services/organizationService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker,
  },

  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      headers: [
      {
        text: 'Employee',
        align: 'start',
        value: 'profile',
      },
      { text: 'Activity Type', value: '' },
      { text: 'Date', value: '' },
      { text: 'Action', value: 'actions', sortable: false },
    ],
      submitted: false,
      loading: false,
      error: "",
      fro: "",
      employee: {},
      employees: [],
      performanceActivities: [],
      company: authenticationService.currentOfficeValue,
    };
  },
  watch: {
    employeeId(value) {
      var employee = this.employees.find(c => c.id === value);
      this.from = employee.designation.id;
      this.fromName = employee.designation.name;
    }
  },

  methods: {
    openDialog(){
      this.dialog = true
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    }
  },

  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false,
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "performanceActivity",
};
</script>


// WEBPACK FOOTER //
// src/components/performance/performanceActivity.vue